import { getPagePath } from '@spotahome/soyuz/client';

const getCityUrl = (city, suffix) => {
  const url = getPagePath('marketplace.free-search', {
    params: { locationString: city }
  });
  return suffix ? decodeURIComponent(`${url}/${suffix}`) : url;
};

export default getCityUrl;
